import { gql } from '@apollo/client';

const UPDATE_HELP_TOPIC = gql`mutation updateHelpTopic($input: UpdateHelpTopicInput!) {
  helpContext {
    updateHelpTopic(input: $input) {
			success
			message
			topic {
				topicId: id
				parentTopicId: parentId
				index
				title: name
				description
			}
    }
  }
}`;

export default UPDATE_HELP_TOPIC;
